var exports = {
  "dn": "ServerTagBadge.module__hitTarget___SmpBQn",
  "VN": "ServerTagBadge.module__popoutNoShadow___SmpBQn",
  "qS": "ServerTagBadge.module__badge___SmpBQn",
  "EL": "ServerTagBadge.module__badgeSm___SmpBQn",
  "Lf": "ServerTagBadge.module__badgeMd___SmpBQn",
  "em": "ServerTagBadge.module__tagText___SmpBQn",
};

module.exports = exports;
